import React from 'react';
import {registerUser} from '../services/UserService'
import Navbar from "./components/Navbar";
import NotificationPanel from "./components/NotificationPanel";

class RegisterUser extends React.Component {
    constructor(props) {
        super(props);
        var baseUrl = window.location.href;
        this.state = {
           uuidToken: baseUrl.substring(baseUrl.lastIndexOf('/') + 1),
           username: "",
           password: "",
           notifyMessage: ""
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange = (e) => {
        if (e.target.name === "username") {
            this.setState({ username: e.target.value});
        }
        else if (e.target.name === "password") {
            this.setState({ password: e.target.value});
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.username === "" || this.state.password === "") {
            this.setState({notifyMessage: "Empty username/password field"});
        } else {
            registerUser(this.state.uuidToken, this.state.username, this.state.password)
            .then(response =>
                {
                    if (response.ok){
                        window.alert("User registered successfully.\nPlease login with previously inputted credentials to access the application.");
                        window.location.pathname = "/";
                    } else {
                        this.setState({ notifyMessage: "Error: Invalid invite OR username already exists."});
                    }
                }
            );
        }
    };

    render() {
    return (
    <>
        <Navbar loggedIn={false} />
        <div className="row" style={{marginLeft: "4%", marginRight: "4%"}}>
            <h1>
                Register new user
            </h1>
            <form style={{width: "350px", paddingTop:"10px"}}>
                <div className="form-group">
                  <label>Username</label>
                  <input className="form-control" type="email" name="username" onChange={(e) => this.handleInputChange(e)} />
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <input className="form-control" type="password" name="password" onChange={(e) => this.handleInputChange(e)}/>
                </div>
                <button type="submit" className="btn btn-primary" onClick={this.handleSubmit} >
                  Submit
                </button>
                <NotificationPanel type="error" message={this.state.notifyMessage}/>
            </form>
        </div>
    </>
    );
    }
}

export default RegisterUser;
